import { Button } from "@/components/ui/button.tsx";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog.tsx";
import { PlusIcon } from "lucide-react";
import { useState } from "react";
import { SessionForm } from "./session-form.tsx";

interface AddSessionProps {
  menteeId: string;
}

export function AddSession({ menteeId }: AddSessionProps) {
  const [showForm, setShowForm] = useState(false);
  return (
    <>
      <Button className="w-full" onClick={() => setShowForm(true)}>
        Add Session
        <PlusIcon size={22} className="ml-4" />
      </Button>

      <Dialog open={showForm} onOpenChange={setShowForm}>
        <DialogContent className="w-full max-w-lg">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold leading-7 text-black">
              Schedule a Session
            </DialogTitle>
          </DialogHeader>
          <SessionForm
            closeForm={() => setShowForm(false)}
            menteeId={menteeId}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
